type ViolationConfig = {
  type: 'icon' | 'exclamation'
  shape?: 'square' | 'triangle' | 'circle'
  variant?: 'alert'
  badgeContent?: string
  iconClassName?: string
  className?: string
}

export const getViolationConfig = (
  violationType: string,
): ViolationConfig | null => {
  switch (violationType) {
    case 'NN':
      return {
        type: 'icon',
        shape: 'square',
        variant: 'alert',
        badgeContent: 'NN',
        iconClassName: 'tw-text-error',
        className: 'tw-text-error tw-font-semibold',
      }

    case 'BPN':
      return {
        type: 'icon',
        shape: 'triangle',
        variant: 'alert',
        badgeContent: 'BPN',
      }

    case 'PN':
      return {
        type: 'icon',
        shape: 'circle',
        variant: 'alert',
        badgeContent: 'PN',
      }

    case 'ZN':
      return {
        type: 'exclamation',
        badgeContent: 'ZN',
      }

    default:
      return null
  }
}
